<div class="gb-limit-width">
  <h1 translate="STAFF.AWS_TOOLS.TITLE"></h1>
  <div class="description-container">
    <p [innerHtml]="'STAFF.AWS_TOOLS.DESCRIPTION' | translate"></p>
    <p [innerHtml]="'STAFF.AWS_TOOLS.NOTE' | translate"></p>
  </div>

  <div class="button-container">
    <button (click)="createInvalidation()" mat-flat-button>
      <div class="button-inner">
        <gb-icon icon="cloud-done"></gb-icon>
        <span translate="STAFF.AWS_TOOLS.CREATE_INVALIDATION"></span>
      </div>
    </button>
  </div>
</div>
